import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/query-client';
import { AuthProvider } from './hooks/useAuth';
import { FiltersProvider } from './hooks/useFilters';
import { ThemeProvider } from './hooks/useTheme';
import { ToastProvider } from './hooks/useToasts';
import { ToastViewport } from './components/ToastViewport';
import { AppRoutes } from './routes/AppRoutes';

/**
 * Composición de proveedores.
 *
 * `AuthProvider` va dentro de `QueryClientProvider` porque la sesión se resuelve
 * con una consulta (`GET /api/auth/me`), y `FiltersProvider` dentro de aquélla
 * porque los catálogos de filtros requieren sesión activa.
 */
export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ToastProvider>
          <BrowserRouter>
            <AuthProvider>
              <FiltersProvider>
                <AppRoutes />
                <ToastViewport />
              </FiltersProvider>
            </AuthProvider>
          </BrowserRouter>
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
